import React, { useRef, useState } from 'react'
import { useEffect } from 'react'

const useFileUpload = (value, setValue, multiple) => {
    const inputRef = useRef(null)
    const dropZoneRef = useRef(null)
    const [isDragging, setIsDragging] = useState(false)

    useEffect(() => {
        if (value?.isEmpty() && inputRef.current)
            inputRef.current.value = ""
    }, [value])


    const stopDefaultEvent = (e) => {
        e.preventDefault()
        e.stopPropagation()
    }

    const handleFileSelect = (file) =>
        setValue(!multiple ? [file[0]] : [...value, ...file])


    const handleDragEnter = (e) => {
        stopDefaultEvent(e)
        setIsDragging(true)
    }

    const handleDragLeave = (e) => {
        stopDefaultEvent(e)
        setIsDragging(false)
    }

    const handleDrop = (e) => {
        stopDefaultEvent(e)
        setIsDragging(false)
        const files = e.dataTransfer.files
        if (files && files.length > 0) {
            handleFileSelect(files)
        }
    }

    const handleInputChange = (e) => {
        const files = e.target.files
        if (files && files.length > 0) {
            handleFileSelect(files)
        }
    }

    const handleRemove = (e, index) => {
        stopDefaultEvent(e)
        setValue(value.filter((_, i) => i !== index))
        if (inputRef.current) inputRef.current.value = ""
    }

    const getFileIcon = (fileName) => {
        if (fileName) {
            if (fileName.endsWith('.pdf')) return 'mdi:file-pdf-box'
            if (fileName.endsWith('.jpg') || fileName.endsWith('.jpeg') || fileName.endsWith('.png'.toUpperCase())) return 'mdi:image-outline'
            if (fileName.endsWith('.doc') || fileName.endsWith('.docx')) return 'mdi:file-word-box'
            if (fileName.endsWith('.xls') || fileName.endsWith('.xlsx')) return 'mdi:file-excel-box'
            return 'mdi:file-document'
        }
        return 'mdi:cloud-upload-outline'
    }
    const formatFileSize = (bytes) => {
        if (!bytes) return ''
        if (bytes < 1024) return bytes + ' B'
        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + ' KB'
        return (bytes / (1024 * 1024)).toFixed(2) + ' MB'
    }

    return {
        isDragging,
        dropZoneRef,
        inputRef,
        getFileIcon,
        formatFileSize,
        handleFileSelect,
        handleDragEnter,
        handleDragLeave,
        handleDrop,
        handleInputChange,
        handleRemove,
        stopDefaultEvent
    }
}

export default useFileUpload